import {
  set_text_field_focus,
  show_send_shoutout_modal,
  set_send_shoutout_modal_profile_user,
  show_send_shoutout_modal_with_user
} from './types';

export const setTextFieldFocus = focus => {
  return dispatch => {
    dispatch({ type: set_text_field_focus, payload: focus });
  };
};

export const setShowSendShoutoutModal = show => {
  return dispatch => {
    if (!show) dispatch(setTextFieldFocus(false));
    dispatch({ type: show_send_shoutout_modal, payload: show });
  };
};

export const setSendShoutoutModalProfileUser = user => {
  return dispatch => {
    dispatch({ type: set_send_shoutout_modal_profile_user, payload: user });
  };
};

export const setShowSendShoutoutModalWithUser = show => {
  return dispatch => {
    dispatch({ type: show_send_shoutout_modal_with_user, payload: show });
  };
};



// WEBPACK FOOTER //
// ./src/actions/HotkeyActions.js